import { LockBadge } from '@/shared/quizList/QuizListItem/LockBadge';
import { createZepetoImageMonitor } from '@/shared/utils/zepetoImageMonitor';
import { cn } from '@/utils/tailwind.util';
import { type HeroCardData } from '../../types';
import { TypeBadge } from './TypeBadge';
type HeroImageProps = {
  data: HeroCardData['image'];
  className?: string;
};
export const HeroImage = ({
  data,
  className
}: HeroImageProps) => {
  return <div className={cn('relative overflow-hidden', 'tablet-sm:h-[134px] tablet-sm:w-[206px]', 'h-[85px] w-[130px] shrink-0 box-content', className)} data-sentry-component="HeroImage" data-sentry-source-file="HeroImage.tsx">
      <img src={data.url} alt="quiz thumbnail" className="size-full object-cover" {...createZepetoImageMonitor('selected-map')} />

      {data.isLocked && <LockBadge className="left-2xs top-2xs p-xs" iconSize="sm" iconClassName="tablet-sm:size-lg" />}

      {/* Type Badge (순서 풀이) at bottom - desktop only */}
      <div className="absolute bottom-2xs left-2xs hidden tablet-sm:block">
        <TypeBadge type={data.type} data-sentry-element="TypeBadge" data-sentry-source-file="HeroImage.tsx" />
      </div>
    </div>;
};